import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useAccountingReports } from "./useAccountingReports";
import React from "react";

const AccountingReports = () => {
  const { selectedTab, updateSelectedTab, mainTabs } = useAccountingReports();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Account Reports"
      description="View and manage your financial reports, including profit and loss
              statements, balance sheets, and cash flow statements."
    >
      <secondaryComponents.LoaderHelper classNames="mt-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${styles["accounting"]} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Accounting Reports</h4>
            <p>
              View and manage your financial reports, including profit and loss
              statements, balance sheets, and cash flow statements.
            </p>

            <div className="mt-3">
              <div
                className={`${globalStyles.rowNavigations} mb-4`}
                style={{ overflowY: "visible" }}
              >
                {mainTabs?.map((item, index) => {
                  const key = item?.key;
                  return (
                    <React.Fragment key={index}>
                      <secondaryComponents.NavigateWithPermission
                        permissionParentKey="Accounting"
                        showOnLocalSetup={item?.showOnLocalSetup}
                      >
                        {/* eslint-disable-next-line */}
                        <a
                          className={`${globalStyles.rowNavigations__item} ${
                            key === selectedTab ? globalStyles.active : ""
                          }`}
                          onClick={() => {
                            updateSelectedTab(key);
                          }}
                        >
                          {item?.label}
                        </a>
                      </secondaryComponents.NavigateWithPermission>
                    </React.Fragment>
                  );
                })}
                {/* <secondaryComponents.AccountingReportsDropdown
                  selectedTab={selectedTab}
                  updateSelectedTab={updateSelectedTab}
                  otherTabs={otherTabs}
                /> */}
              </div>
              <div
                className={`${globalStyles.tableWrapper} ${styles["accounting__tabs"]}`}
              >
                <secondaryComponents.LoaderHelper classNames={"pt-5"}>
                  {selectedTab === "trial_balance_tab" && (
                    <secondaryComponents.AccountingTrialBalance />
                  )}
                  {selectedTab === "profit_and_loss_tab" && (
                    <secondaryComponents.AccountingProfitLoss />
                  )}
                  {selectedTab === "balance_sheet_tab" && (
                    <secondaryComponents.AccountingBalanceSheet />
                  )}
                  {selectedTab === "cash_flow_statement_tab" && (
                    <secondaryComponents.AccountingCashFlow />
                  )}
                  {selectedTab === "ageing_payables_tab" && (
                    <p>Ageing Payables page</p>
                  )}
                  {selectedTab === "ageing_receivables_tab" && (
                    <p>Ageing Receivables page</p>
                  )}
                  {selectedTab === "journal_report_tab" && (
                    <p>Journal Report page</p>
                  )}
                  {selectedTab === "customer_statement_tab" && (
                    <p>Customer Statement page</p>
                  )}
                  {selectedTab === "supplier_statement_tab" && (
                    <p>Supplier Statement page</p>
                  )}
                  {selectedTab === "vat_summary_tab" && (
                    <p>VAT Summary / VAT Ledger page</p>
                  )}
                  {selectedTab === "bank_reconciliation_report_tab" && (
                    <p>Bank Reconciliation Report page</p>
                  )}
                  {selectedTab === "inventory_valuation_report_tab" && (
                    <p>Inventory Valuation Report page</p>
                  )}
                  {selectedTab === "audit_trail_report_tab" && (
                    <p>Audit Trail Report page</p>
                  )}
                </secondaryComponents.LoaderHelper>
              </div>
            </div>
          </div>
        </motion.div>
      </secondaryComponents.LoaderHelper>
    </secondaryComponents.MetaSetter>
  );
};

export default AccountingReports;
